import React, { useState } from "react";
import BodyText from "../../../elements/body-text";
import Checkbox from "../../../elements/checkbox";

const CashOptions = ({ checkboxes, description, onChange }) => {
  return (
    <div className="cash">
      <BodyText html={description} />
      {checkboxes &&
        checkboxes.map((checkbox, index) => {
          return (
            <Checkbox
              {...checkbox}
              onChange={(value) => onChange(index, value, checkbox)}
            />
          );
        })}
    </div>
  );
};

export default CashOptions;
